import { IonPage } from '@ionic/react';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { HomeMessages } from '../intl/HomeMessages';
import { selectAuthUserInfo } from '../redux/auth/selectors';
import { fetchUserInfo } from '../redux/auth/thunk/fetchUserInfo';
import { AppState } from '../redux/types';
import { useSocket } from '../utils/socket';
import { SocketContextPortal } from '../utils/socket/context/portalSocketContext';
import moment from 'moment';
import { englishOnlyIntl, useGA4 } from '../utils/ga4';
import { TosComponent } from '../components/TosComponent';

export const TosPage: React.FC = () => {
  document.title = englishOnlyIntl.formatMessage(HomeMessages.reviewTosHeader);
  useGA4();

  const dispatch = useDispatch<ThunkDispatch<AppState, undefined, AnyAction>>();
  const user = useSelector(selectAuthUserInfo);
  const { update: updateUser } = useSocket(SocketContextPortal, 'users');
  const [isLoading, setLoading] = useState(false);

  const handleAccept = useCallback(async () => {
    try {
      setLoading(true);
      const _id = user?.id;
      if (!_id) throw new Error('No user id exists!');

      await updateUser({
        _id,
        update: {
          $set: { sentinelLinkTOSAcceptedAt: moment().toISOString(true) },
        },
      });
      dispatch(fetchUserInfo());
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [dispatch, updateUser, user?.id]);

  if (user?.tosAcceptedAt) {
    return <Redirect to="/home" />;
  }

  return (
    <IonPage>
      <TosComponent isLoading={isLoading} handleAccept={handleAccept} />
    </IonPage>
  );
};
